import { useEffect } from 'react';
import { createFileRoute } from '@tanstack/react-router';

import { AppConfigs } from '@/config';

function WildcardRedirect() {
  useEffect(() => {
    const currentPath = window.location.pathname;

    // Don't redirect invitations or token callback paths
    if (currentPath !== '/invitations' && !currentPath.includes('/token/callback')) {
      window.location.href = AppConfigs.atlasEnvUrl.toString();
    }
  }, []);
  return null;
}

export const Route = createFileRoute('/$')({
  component: WildcardRedirect,
});
